/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 flash.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Flash(props) {
  const { nodes, materials } = useGLTF('/media/models/flash.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.flash.geometry} material={materials['Default OBJ']} />
    </group>
  )
}

useGLTF.preload('/media/models/flash.glb')
